import { render, staticRenderFns } from "./setMessageReminder.vue?vue&type=template&id=3b6247f7&"
import script from "./setMessageReminder.vue?vue&type=script&lang=js&"
export * from "./setMessageReminder.vue?vue&type=script&lang=js&"
import style0 from "./setMessageReminder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports